var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgXls = function SvgXls(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-14": 11,
    "data-width-16": 12,
    "data-width-20": 15,
    "data-width-24": 18,
    "data-width-28": 21,
    "data-width-32": 24,
    "data-width-36": 27,
    "data-width-40": 30,
    viewBox: "0 0 11.8 11.7",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.5 11.667h8.667a1.5 1.5 0 0 0 1.533-1.5V4.42a1.83 1.83 0 0 0-.54-1.333L8.613.54A1.83 1.83 0 0 0 7.28 0H1.5A1.5 1.5 0 0 0 0 1.5v8.667a1.5 1.5 0 0 0 1.5 1.5M1.148 1.149A.5.5 0 0 1 1.5 1h5.78a.83.83 0 0 1 .593.247l2.547 2.547a.83.83 0 0 1 .247.593v5.78a.507.507 0 0 1-.5.5H1.5a.506.506 0 0 1-.5-.5V1.5a.5.5 0 0 1 .148-.351M5.3 8.054h1.233a.387.387 0 0 0 0-.774h-.846V5.334a.387.387 0 0 0-.658-.273.38.38 0 0 0-.109.273v2.333a.38.38 0 0 0 .38.387m3.2 0h-.36a.9.9 0 0 1-.853-.62.393.393 0 0 1 .74-.267.13.13 0 0 0 .126.087H8.5a.13.13 0 0 0 .127-.087c0-.107 0-.16-.047-.2a.2.2 0 0 0-.14-.08l-.373-.067a1.01 1.01 0 0 1-.814-.986.87.87 0 0 1 .267-.64.89.89 0 0 1 .667-.267H8.5a.9.9 0 0 1 .853.62.383.383 0 1 1-.726.24A.13.13 0 0 0 8.5 5.7h-.36a.15.15 0 0 0-.093.034l-.04.066a.24.24 0 0 0 .193.267l.373.067c.235.048.446.178.594.366a.99.99 0 0 1 .18.96.91.91 0 0 1-.847.594m-4-2.5-.667.946.68.954a.387.387 0 0 1-.313.606.38.38 0 0 1-.313-.166l-.52-.727-.52.713a.38.38 0 0 1-.314.167.387.387 0 0 1-.313-.607l.667-.946-.667-.947a.383.383 0 0 1 .627-.44l.52.727.506-.72a.383.383 0 0 1 .627.44",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgXls);
export default ForwardRef;